import {useGameStore} from "@/stores/gameStore";
import {usePlayerRelationStore} from "@/stores/playerRelations";
import type Turn from "@/types/PublicRouter/Turn";
import { logger } from '@/models/logger';

export default class PublicRouter {

    private gameStore = useGameStore()
    private playerRelationStore = usePlayerRelationStore()

    public route(event: string, data: Array<never>): void {
        logger.debug('Routing public event: ' + event)
        switch (event) {
            case 'turn':
                // Sync Initial Map Data
                this.turn(data)
                break
            case 'player_online_status_update':
                this.playerOnlineStatusUpdate(data)
                break
            case 'ship_command_block_enabled':
                this.setShipCommandBlock(true)
                break;
            case 'ship_command_block_disabled':
                this.setShipCommandBlock(false)
                break;
            default:
                logger.warn('Unknown event: ' + event)
                break
        }
    }

    private turn(data: Array<never>): void {
        const eventData = data as unknown as Turn
        this.gameStore.turn = eventData.turn
        this.gameStore.dayTurnedAt = (Date.now() / 1000) - eventData.dayOffset;
        this.gameStore.weekTurnedAt = (Date.now() / 1000) - eventData.weekOffset
    }

    private playerOnlineStatusUpdate(data: Array<never>): void {
        const eventData = data as unknown as { onlinePlayers: Record<string, number>, serverTimestamp: number }
        this.playerRelationStore.updateOnlineStatus(eventData.onlinePlayers, eventData.serverTimestamp)
    }

    private setShipCommandBlock(enabled: boolean): void {
        this.gameStore.shipCommandBlock = enabled
    }
}
